import { Action, Location } from "history";
import {
  UpdateUrlHistoryAction,
  UPDATE_INSIGHTS_URL_HISTORY,
  UPDATE_MONITORING_URL_HISTORY,
  UPDATE_ACTIONS_URL_HISTORY,
} from "./actionTypes";

function generateAction(actionType: UpdateUrlHistoryAction["type"]) {
  return (hist: Location, updateType: Action): UpdateUrlHistoryAction => {
    const location = { ...hist, path: `${hist.pathname}${hist.search}` };
    return {
      type: actionType,
      location,
      updateType,
    };
  };
}

export const updateInsightsUrlHistory = generateAction(
  UPDATE_INSIGHTS_URL_HISTORY
);
export const updateMonitoringUrlHistory = generateAction(
  UPDATE_MONITORING_URL_HISTORY
);
export const updateActionsUrlHistory = generateAction(
  UPDATE_ACTIONS_URL_HISTORY
);
